import { Context } from "@nuxt/types";

import Api from "@/utils/api";
import debounce from "@/utils/debounce";

const DEFAULT_FOLLOW_LIMIT = 36;

export default class FollowsApi extends Api {
  readonly url = "/v2/follows/";

  constructor($axios: Context["$axios"]) {
    super("followerService", $axios);
  }

  async get({ profileIds, beforeId, afterId, excludes, limit }: GetFollowsParams) {
    return await this.request<ManyFollowsResponse>({
      method: "GET",
      url: this.url,
      params: {
        profile_ids: profileIds,
        before_id: beforeId,
        after_id: afterId,
        excludes,
        limit,
      },
    });
  }

  async post({ profileIds }: FollowCreatorParams) {
    return await this.request<FollowResponse>({
      method: "POST",
      url: this.url,
      data: {
        follows: profileIds.map((id) => {
          return {
            profile_id: id,
          };
        }),
      },
    });
  }

  async delete({ profileIds }: UnfollowCreatorParams) {
    return await this.request({
      method: "DELETE",
      url: this.url,
      params: { profile_ids: profileIds },
    });
  }

  @debounce({ timeout: 50, aggregate: true, batch: DEFAULT_FOLLOW_LIMIT })
  async followCreatorAggregate(...profileIds: string[]) {
    return await this.post({ profileIds });
  }

  @debounce({ timeout: 50, aggregate: true, batch: DEFAULT_FOLLOW_LIMIT })
  async unfollowCreatorAggregate(...profileIds: string[]) {
    return await this.delete({ profileIds });
  }

  @debounce({ timeout: 50, aggregate: true, batch: DEFAULT_FOLLOW_LIMIT })
  async getOne(...profileIds: string[]) {
    return await this.get({ profileIds });
  }
}
